// extracted by mini-css-extract-plugin
export var errorIcon = "_n8-1";
export var nameLogo = "_n8-0";